import { useTranslation } from 'react-i18next';

const Error = () => {
  const [t] = useTranslation('error');
  return <div>{t('pageNotFound')}</div>;
};

export default Error;
